import React, { Component } from 'react'
import Stripes from 'components/Stripes'
import _PageHeader_Loader_Wrapper from 'containers/Page/Header/_components/Loader/_styles/_PageHeader_Loader_Wrapper'
import _PageHeader_Loader_Inner from 'containers/Page/Header/_components/Loader/_styles/_PageHeader_Loader_Inner'
import _PageHeader_Logo from 'containers/Page/Header/_components/Logo/_PageHeader_Logo'

export default class _PageHeader_Loader extends Component {
  render () {
    return (
      <_PageHeader_Loader_Wrapper>

        <_PageHeader_Loader_Inner>
          <_PageHeader_Logo to='/' />
        </_PageHeader_Loader_Inner>

        <Stripes loading />

      </_PageHeader_Loader_Wrapper>
    )
  }
}
